import { LawTechSlider } from './LawTechSlider'
import { useWhoArticle } from 'common/hooks/useWhoArticle'
const LawTech = () => {
  const {
    loadWhoArticles,
    whoArticles,
    articlesCount,
    isLoading,
    isLoadingMore,
  } = useWhoArticle()

  return (
    <div className='flex flex-col items-center self-stretch gap-8 px-5   lg:px-10 flex-row lg:gap-10 2xl:px-20 2xl:gap-15 3xl:px-[190px] my-[40px] 3xl:my-[200px] 2xl:my-[150px] lg:my-[100px] '>
      <div className='flex flex-col items-center gap-3 2xl:gap-4 3xl:gap-6 w-full self-stretch'>
        <h2 className='text-center text-[18px] font-bold leading-6 tracking-wide text-[#001A3D] lg:text-2xl lg:leading-8 2xl:text-[32px] 3xl:text-[40px]'>
          Lawtech Around the World
        </h2>
        <p
          className='text-center text-[#586885]  font-medium text-base leading-6 tracking-[0.4px] lg:text-base lg:leading-6 lg:font-medium
             2xl:text-lg 2xl:leading-6 2xl:font-bold
             3xl:text-2xl 3xl:leading-8 '
        >
          Read about our founder's exploration of legal markets and technology
        </p>

        <LawTechSlider
          articles={whoArticles}
          articlesCount={articlesCount}
          isLoading={isLoading}
          isLoadingMore={isLoadingMore}
          loadMore={loadWhoArticles}
        />
      </div>
    </div>
  )
}
export default LawTech
